import styled from "styled-components";

export const StyledDiv = styled.div`
  margin-left: 6em;
`;
